export const getUnitatColor = (unitat: string | undefined | null) => {
	if (!unitat) return '#1f1099'; // Default Agrupament
	switch (unitat.toLowerCase()) {
	case 'cills':
		return '#f5a431';
	case 'llids':
		return '#d4c41c'; // Darker yellow
	case 'rings':
		return '#1c99fa';
	case 'pics':
		return '#b93b33'; // Less aggressive red
	case 'trucs':
		return '#0d9108';
	case 'agrupament':
	default:
		return '#4338ca'; // Softer indigo (was #1f1099 — too dark for AGR tags)
	}
};

// Light tint versions for backgrounds (high contrast with dark text)
export const getUnitatBgColor = (unitat: string | undefined | null) => {
	if (!unitat) return '#eeeeff'; // Default Agrupament light
	switch (unitat.toLowerCase()) {
	case 'cills':
		return '#fef3e2';
	case 'llids':
		return '#faf9dc';
	case 'rings':
		return '#e6f4ff';
	case 'pics':
		return '#fbeaea';
	case 'trucs':
		return '#e6f5e6';
	case 'agrupament':
	default:
		return '#eeeeff';
	}
};

export const getUnitatName = (unitat: string | undefined | null) => {
	if (!unitat) return 'Agrupament';
	switch (unitat.toLowerCase()) {
	case 'cills':
		return 'Castors i Llúdrigues';
	case 'llids':
		return 'Llops i Daines';
	case 'rings':
		return 'Ràngers i Noies Guia';
	case 'pics':
		return 'Pioners i Caravel·les';
	case 'trucs':
		return 'Trucs';
	case 'agrupament':
	default:
		return 'Agrupament';
	}
};
